import React from "react";
import { Button } from "@/components/ui/button";

export const PaginationBar = ({ page, pages, onChange }) => {
  if (!pages || pages <= 1) return null;
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-zinc-200">
      <div className="label-overline">
        Page <span className="font-mono">{page}</span> of <span className="font-mono">{pages}</span>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" className="rounded-sm"
                data-testid="pagination-prev"
                disabled={page <= 1}
                onClick={() => onChange(page - 1)}>Prev</Button>
        <Button variant="outline" size="sm" className="rounded-sm"
                data-testid="pagination-next"
                disabled={page >= pages}
                onClick={() => onChange(page + 1)}>Next</Button>
      </div>
    </div>
  );
};
